
<div class="fixed bottom-8 left-8 w-full flex justify-start items-end pointer-events-none z-50">
  <!--.w-full.flex.flex-col.items-center.space-y-4(class='sm:items-end', *ngFor="let message of displayQueue; let num = index;")-->
  @for (message of displayQueue; track message; let num = $index) {
    <div class="w-full absolute" [style]="'bottom: ' + (10 * num) + 'px;z-index: ' + 10 * num * -1 + ';'">
      <div class="max-w-sm w-full bg-white shadow-lg ring-1 ring-black ring-opacity-5 overflow-hidden pointer-events-auto">
        <div class="p-4">
          <div class="flex items-start">
            <div class="flex-shrink-0"><i class="text-2xl" [class]="message.severity | infoMessageIcon"></i></div>
            <div class="ml-3 w-0 flex-1 pt-1">
              <p class="text-sm font-medium text-gray-900">{{ message.title | shortText:35 }}</p>
              <p class="mt-1 text-sm text-gray-500">{{ message.completeMessage | shortText:120 }}</p>
            </div>
            <div class="ml-4 flex-shrink-0 flex">
              <button class="text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" type="button" (click)="close(message)"><span class="sr-only">Close</span>
              <!-- Heroicon name: solid/x-->
              <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                <path fill-rule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clip-rule="evenodd"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
</div>